import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const GiveawayRules = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#1e3a5f] py-8 px-4">
        <div className="container mx-auto max-w-3xl">
          <div className="flex items-start justify-between mb-4">
            <Link to="/giveaway" className="inline-flex items-center text-white/70 hover:text-white text-sm transition-colors">
              <ArrowLeft className="mr-1 w-4 h-4" /> Back to Giveaway
            </Link>
            <a href="tel:4258902558" className="text-xl font-bold text-white hover:text-[#d97706] transition-colors" data-testid="rules-header-phone-link">
              425.890.2558
            </a>
          </div>
          <h1 className="text-3xl font-bold text-white">Official Rules & Terms</h1>
          <p className="text-gray-300 mt-2">CDL Scholarship Giveaway — Diamond Trucking School</p>
        </div>
      </div>

      <div className="container mx-auto max-w-3xl py-10 px-4">
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-gray-700 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">1. Sponsor</h2>
            <p>This giveaway ("Giveaway") is sponsored by Diamond Trucking School, located at 8217 44th Ave W. Bldg. F, Suite B, Mukilteo, WA 98275 ("Sponsor").</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">2. Giveaway Period</h2>
            <p>The Giveaway begins on June 1, 2026, at 12:00 AM PT and ends on July 1, 2026, at 11:59 PM PT. The winner will be announced on or around July 3, 2026.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">3. Eligibility</h2>
            <p>To be eligible, entrants must meet all of the following requirements:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Be at least 18 years of age at the time of entry</li>
              <li>Be a resident of Washington State</li>
              <li>Be able to pass a DOT physical examination</li>
              <li>Be able to pass a DOT drug test</li>
              <li>Hold a valid Washington State driver's license</li>
              <li>Be a U.S. citizen or lawful permanent resident (Green Card holder)</li>
              <li>Be able to read, write, speak, and understand English</li>
            </ul>
            <p className="mt-2">The winner must provide a copy of their driving record upon selection. Employees of Diamond Trucking School and their immediate family members are not eligible.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">4. How to Enter</h2>
            <p>No purchase necessary. To enter, complete the online entry form at diamond-trucking-school.com/giveaway during the Giveaway Period. Limit one (1) entry per person. Multiple entries from the same individual will be disqualified.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">5. Prize</h2>
            <p>One (1) winner will receive a full tuition scholarship for a Class A CDL training course at Diamond Trucking School. The total approximate retail value (ARV) of the prize is <strong>$6,045.90</strong>.</p>
            <p className="mt-2">The scholarship covers:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1">
              <li>Tuition</li>
              <li>Books and materials</li>
              <li>DOT physical examination</li>
              <li>Drug test</li>
            </ul>
            <p className="mt-2"><strong>The winner remains responsible for:</strong> permit fees, final skills test fees, and final licensing fees. These costs are not included in the scholarship.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">6. Winner Selection & Notification</h2>
            <p>The winner will be selected by Diamond Trucking School after eligibility screening and phone verification. The winner will be notified by phone and/or email. If the selected winner cannot be reached within five (5) business days, an alternate winner may be selected.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">7. Prize Conditions</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>The prize has no cash value and is non-transferable</li>
              <li>The prize cannot be exchanged for cash or other goods/services</li>
              <li>The winner must begin using the scholarship within 180 days from the date of winner selection</li>
              <li>The winner must meet all eligibility requirements and pass required screenings</li>
              <li>Diamond Trucking School reserves the right to verify all information provided</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">8. Privacy</h2>
            <p>Personal information collected through this Giveaway will be used solely for the purpose of administering the Giveaway and contacting entrants. Information will not be sold or shared with third parties except as required by law. For more information, see our <Link to="/privacy-policy" className="text-[#d97706] hover:underline">Privacy Policy</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">9. General Conditions</h2>
            <p>By entering, each entrant agrees to abide by these Official Rules and the decisions of the Sponsor, which are final and binding. The Sponsor reserves the right to cancel, suspend, or modify the Giveaway if fraud, technical issues, or any other factor beyond the Sponsor's control impairs the integrity of the Giveaway.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">10. Contact</h2>
            <p>For questions about this Giveaway, contact Diamond Trucking School at:</p>
            <p className="mt-1">Email: <a href="mailto:diamondtruckingschool@gmail.com" className="text-[#d97706] hover:underline">diamondtruckingschool@gmail.com</a></p>
            <p>Phone: <a href="tel:4258902558" className="text-[#d97706] hover:underline">(425) 890-2558</a></p>
          </section>

          <div className="pt-4 border-t text-sm text-gray-500 text-center">
            <p>Last updated: June 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};
